// Statischer Referenz-Logo-Grid für Content-/Säulen-Seiten.
// Bewusst KEIN Marquee/JS/Full-Bleed (der animierte LogoBanner ist nur für die
// Homepage gedacht und verrutscht im schmalen Container) — robust + prerender-fest.
import profinaLogo from "../assets/banner/profina_logo_extern_cmyk.jpg";
import pkmLogo from "../assets/banner/Logo_PKM_1mPfad.png";
import impactLogo from "../assets/banner/Impact_Logo_RGB_RZ_NEU.jpg";
import ffLogo from "../assets/banner/LOGO_FF.png";
import dpcLogo from "../assets/banner/logo_dpc_Finanzkonzept_4c.png";
import dasgLogo from "../assets/banner/logo_dasg.jpg";
import inaInternetLogo from "../assets/banner/Ina Internet Group.jpg";
import feLogo from "../assets/banner/FE_LOGO_CMYK.jpg";
import fbdLogo from "../assets/banner/FBD_Logo_Vektor.png";
import adcuriLogo from "../assets/banner/ADCURI-Logo.png";
import barmeniaLogo from "../assets/banner/00_Barmenia_logo_claim_weiss_Punze_blau.png";

const LOGOS = [
  { src: barmeniaLogo, alt: "Barmenia", bg: true },
  { src: adcuriLogo, alt: "ADCURI" },
  { src: profinaLogo, alt: "Profina" },
  { src: impactLogo, alt: "Impact" },
  { src: dpcLogo, alt: "DPC Finanzkonzept" },
  { src: dasgLogo, alt: "DASG" },
  { src: feLogo, alt: "FE" },
  { src: fbdLogo, alt: "FBD" },
  { src: ffLogo, alt: "FF" },
  { src: pkmLogo, alt: "PKM" },
  { src: inaInternetLogo, alt: "INA Internet Group" },
];

const LogoStrip = () => (
  <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
    {LOGOS.map((l) => (
      <div
        key={l.alt}
        className={`flex items-center justify-center ${
          l.bg ? "bg-[#0F1B2D] rounded-md px-3 py-2" : ""
        }`}
      >
        <img
          src={l.src}
          alt={l.alt}
          loading="lazy"
          className="h-8 md:h-9 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
        />
      </div>
    ))}
  </div>
);

export default LogoStrip;
